<div class="modal inmodal fade alert-modal"
     id="alert-modal-id"
     tabindex="-1"
     role="dialog"
     aria-hidden="true"
     #thisModal>
  <div class="modal-dialog alert-modal__alert-dialog"
       role="document">
    <div class="modal-content alert-modal__alert-dialog__alert-content">
      <div class="modal-header alert-modal__alert-dialog__alert-content__alert-header">
        <h4 id="alertModalLabel">
          {{'components.modalAlert.title' | translate}}
        </h4>
        <button type="button"
                class="btn btn-default"
                data-dismiss="modal">
            <span class="fa fa-times"
                  aria-hidden="true">
            </span>
        </button>
      </div>
      <div class="modal-body font-weight-bold alert-modal__alert-dialog__alert-content__alert-body">
        <div class="alert-modal__alert-dialog__alert-content__alert-body__request-content"
             *ngFor="let request of requests">
          <app-request [request]="request"
                         [isEditMode]="false">
          </app-request>
        </div>
      </div>
      <div class="modal-footer alert-modal__alert-dialog__alert-content__alert-footer">
        <button type="button"
                class="btn btn-default"
                (click)="onClose()"
                [disabled]="requests.length == 0"
                data-dismiss="modal">
          <span class="fa fa-check"></span>
          <span>{{'components.modalAlert.confirm' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
